// Generated by scripts/generate-dehumidifier-coverage.py; ONS August 2026.
export const DEHUMIDIFIER_OUTWARD_CODES: readonly string[] = [
  "AL1",
  "AL10",
  "AL2",
  "AL3",
  "AL4",
  "AL5",
  "AL6",
  "AL7",
  "AL8",
  "AL9",
  "BN1",
  "BN10",
  "BN11",
  "BN12",
  "BN13",
  "BN14",
  "BN15",
  "BN16",
  "BN17",
  "BN18",
  "BN2",
  "BN20",
  "BN21",
  "BN22",
  "BN23",
  "BN24",
  "BN25",
  "BN26",
  "BN27",
  "BN3",
  "BN41",
  "BN42",
  "BN43",
  "BN44",
  "BN45",
  "BN5",
  "BN50",
  "BN51",
  "BN52",
  "BN6",
  "BN7",
  "BN8",
  "BN88",
  "BN9",
  "BN95",
  "BN99",
  "BR1",
  "BR2",
  "BR3",
  "BR4",
  "BR5",
  "BR6",
  "BR7",
  "BR8",
  "CB10",
  "CB11",
  "CB21",
  "CB9",
  "CM0",
  "CM1",
  "CM11",
  "CM12",
  "CM13",
  "CM14",
  "CM15",
  "CM16",
  "CM17",
  "CM18",
  "CM19",
  "CM2",
  "CM20",
  "CM21",
  "CM22",
  "CM23",
  "CM24",
  "CM3",
  "CM4",
  "CM5",
  "CM6",
  "CM7",
  "CM77",
  "CM8",
  "CM9",
  "CM92",
  "CM98",
  "CM99",
  "CO1",
  "CO10",
  "CO11",
  "CO12",
  "CO13",
  "CO14",
  "CO15",
  "CO16",
  "CO2",
  "CO3",
  "CO4",
  "CO5",
  "CO6",
  "CO7",
  "CO8",
  "CO9",
  "CR0",
  "CR2",
  "CR3",
  "CR4",
  "CR5",
  "CR6",
  "CR7",
  "CR8",
  "CR9",
  "CR90",
  "CT1",
  "CT10",
  "CT11",
  "CT12",
  "CT13",
  "CT14",
  "CT15",
  "CT16",
  "CT17",
  "CT18",
  "CT19",
  "CT2",
  "CT20",
  "CT21",
  "CT3",
  "CT4",
  "CT5",
  "CT50",
  "CT6",
  "CT7",
  "CT8",
  "CT9",
  "DA1",
  "DA10",
  "DA11",
  "DA12",
  "DA13",
  "DA14",
  "DA15",
  "DA16",
  "DA17",
  "DA18",
  "DA2",
  "DA3",
  "DA4",
  "DA5",
  "DA6",
  "DA7",
  "DA8",
  "DA9",
  "E1",
  "E10",
  "E11",
  "E12",
  "E13",
  "E14",
  "E15",
  "E16",
  "E17",
  "E18",
  "E1W",
  "E2",
  "E20",
  "E22",
  "E3",
  "E4",
  "E5",
  "E6",
  "E7",
  "E8",
  "E9",
  "E98",
  "EC1A",
  "EC1M",
  "EC1N",
  "EC1P",
  "EC1R",
  "EC1V",
  "EC1Y",
  "EC2A",
  "EC2M",
  "EC2N",
  "EC2P",
  "EC2R",
  "EC2V",
  "EC2Y",
  "EC3A",
  "EC3M",
  "EC3N",
  "EC3P",
  "EC3R",
  "EC3V",
  "EC4A",
  "EC4M",
  "EC4N",
  "EC4P",
  "EC4R",
  "EC4V",
  "EC4Y",
  "EN1",
  "EN10",
  "EN11",
  "EN2",
  "EN3",
  "EN4",
  "EN5",
  "EN6",
  "EN7",
  "EN8",
  "EN9",
  "GU1",
  "GU10",
  "GU12",
  "GU14",
  "GU15",
  "GU16",
  "GU18",
  "GU19",
  "GU2",
  "GU20",
  "GU21",
  "GU22",
  "GU23",
  "GU24",
  "GU25",
  "GU26",
  "GU27",
  "GU28",
  "GU29",
  "GU3",
  "GU30",
  "GU31",
  "GU33",
  "GU4",
  "GU46",
  "GU47",
  "GU5",
  "GU6",
  "GU7",
  "GU8",
  "GU9",
  "HA0",
  "HA1",
  "HA2",
  "HA3",
  "HA4",
  "HA5",
  "HA6",
  "HA7",
  "HA8",
  "HA9",
  "HP1",
  "HP10",
  "HP11",
  "HP12",
  "HP13",
  "HP14",
  "HP15",
  "HP16",
  "HP17",
  "HP18",
  "HP19",
  "HP2",
  "HP20",
  "HP21",
  "HP22",
  "HP23",
  "HP27",
  "HP3",
  "HP4",
  "HP5",
  "HP6",
  "HP7",
  "HP8",
  "HP9",
  "IG1",
  "IG10",
  "IG11",
  "IG2",
  "IG3",
  "IG4",
  "IG5",
  "IG6",
  "IG7",
  "IG8",
  "IG9",
  "KT1",
  "KT10",
  "KT11",
  "KT12",
  "KT13",
  "KT14",
  "KT15",
  "KT16",
  "KT17",
  "KT18",
  "KT19",
  "KT2",
  "KT20",
  "KT21",
  "KT22",
  "KT23",
  "KT24",
  "KT3",
  "KT4",
  "KT5",
  "KT6",
  "KT7",
  "KT8",
  "KT9",
  "LU1",
  "LU2",
  "LU6",
  "LU7",
  "ME1",
  "ME10",
  "ME11",
  "ME12",
  "ME13",
  "ME14",
  "ME15",
  "ME16",
  "ME17",
  "ME18",
  "ME19",
  "ME2",
  "ME20",
  "ME3",
  "ME4",
  "ME5",
  "ME6",
  "ME7",
  "ME8",
  "ME9",
  "MK1",
  "MK10",
  "MK11",
  "MK12",
  "MK13",
  "MK14",
  "MK15",
  "MK16",
  "MK17",
  "MK18",
  "MK19",
  "MK2",
  "MK20",
  "MK3",
  "MK4",
  "MK43",
  "MK46",
  "MK5",
  "MK6",
  "MK7",
  "MK77",
  "MK8",
  "MK9",
  "N1",
  "N10",
  "N11",
  "N12",
  "N13",
  "N14",
  "N15",
  "N16",
  "N17",
  "N18",
  "N19",
  "N1C",
  "N1P",
  "N2",
  "N20",
  "N21",
  "N22",
  "N3",
  "N4",
  "N5",
  "N6",
  "N7",
  "N8",
  "N81",
  "N9",
  "NN12",
  "NN13",
  "NN7",
  "NW1",
  "NW10",
  "NW11",
  "NW1W",
  "NW2",
  "NW26",
  "NW3",
  "NW4",
  "NW5",
  "NW6",
  "NW7",
  "NW8",
  "NW9",
  "OX12",
  "OX27",
  "OX33",
  "OX39",
  "OX5",
  "OX9",
  "PO10",
  "PO18",
  "PO19",
  "PO20",
  "PO21",
  "PO22",
  "PO9",
  "RG1",
  "RG10",
  "RG12",
  "RG14",
  "RG17",
  "RG18",
  "RG19",
  "RG2",
  "RG20",
  "RG26",
  "RG27",
  "RG30",
  "RG31",
  "RG4",
  "RG40",
  "RG41",
  "RG42",
  "RG45",
  "RG5",
  "RG6",
  "RG7",
  "RG8",
  "RG9",
  "RH1",
  "RH10",
  "RH11",
  "RH12",
  "RH13",
  "RH14",
  "RH15",
  "RH16",
  "RH17",
  "RH18",
  "RH19",
  "RH2",
  "RH20",
  "RH3",
  "RH4",
  "RH5",
  "RH6",
  "RH7",
  "RH77",
  "RH8",
  "RH9",
  "RM1",
  "RM10",
  "RM11",
  "RM12",
  "RM13",
  "RM14",
  "RM15",
  "RM16",
  "RM17",
  "RM18",
  "RM19",
  "RM2",
  "RM20",
  "RM3",
  "RM4",
  "RM5",
  "RM6",
  "RM7",
  "RM8",
  "RM9",
  "SE1",
  "SE10",
  "SE11",
  "SE12",
  "SE13",
  "SE14",
  "SE15",
  "SE16",
  "SE17",
  "SE18",
  "SE19",
  "SE1P",
  "SE2",
  "SE20",
  "SE21",
  "SE22",
  "SE23",
  "SE24",
  "SE25",
  "SE26",
  "SE27",
  "SE28",
  "SE3",
  "SE4",
  "SE5",
  "SE6",
  "SE7",
  "SE8",
  "SE9",
  "SG1",
  "SG10",
  "SG11",
  "SG12",
  "SG13",
  "SG14",
  "SG16",
  "SG2",
  "SG3",
  "SG4",
  "SG5",
  "SG6",
  "SG7",
  "SG8",
  "SG9",
  "SL0",
  "SL1",
  "SL2",
  "SL3",
  "SL4",
  "SL5",
  "SL6",
  "SL60",
  "SL7",
  "SL8",
  "SL9",
  "SL95",
  "SM1",
  "SM2",
  "SM3",
  "SM4",
  "SM5",
  "SM6",
  "SM7",
  "SN8",
  "SS0",
  "SS1",
  "SS11",
  "SS12",
  "SS13",
  "SS14",
  "SS15",
  "SS16",
  "SS17",
  "SS2",
  "SS22",
  "SS3",
  "SS4",
  "SS5",
  "SS6",
  "SS7",
  "SS8",
  "SS9",
  "SS99",
  "SW10",
  "SW11",
  "SW12",
  "SW13",
  "SW14",
  "SW15",
  "SW16",
  "SW17",
  "SW18",
  "SW19",
  "SW1A",
  "SW1E",
  "SW1H",
  "SW1P",
  "SW1V",
  "SW1W",
  "SW1X",
  "SW1Y",
  "SW2",
  "SW20",
  "SW3",
  "SW4",
  "SW5",
  "SW6",
  "SW7",
  "SW8",
  "SW9",
  "SW95",
  "TN1",
  "TN10",
  "TN11",
  "TN12",
  "TN13",
  "TN14",
  "TN15",
  "TN16",
  "TN17",
  "TN18",
  "TN19",
  "TN2",
  "TN20",
  "TN21",
  "TN22",
  "TN23",
  "TN24",
  "TN25",
  "TN26",
  "TN27",
  "TN28",
  "TN29",
  "TN3",
  "TN30",
  "TN31",
  "TN32",
  "TN33",
  "TN34",
  "TN35",
  "TN36",
  "TN37",
  "TN38",
  "TN39",
  "TN4",
  "TN40",
  "TN5",
  "TN6",
  "TN7",
  "TN8",
  "TN9",
  "TW1",
  "TW10",
  "TW11",
  "TW12",
  "TW13",
  "TW14",
  "TW15",
  "TW16",
  "TW17",
  "TW18",
  "TW19",
  "TW2",
  "TW20",
  "TW3",
  "TW4",
  "TW5",
  "TW6",
  "TW7",
  "TW8",
  "TW9",
  "UB1",
  "UB10",
  "UB11",
  "UB18",
  "UB2",
  "UB3",
  "UB4",
  "UB5",
  "UB6",
  "UB7",
  "UB8",
  "UB9",
  "W10",
  "W11",
  "W12",
  "W13",
  "W14",
  "W1A",
  "W1B",
  "W1C",
  "W1D",
  "W1F",
  "W1G",
  "W1H",
  "W1J",
  "W1K",
  "W1S",
  "W1T",
  "W1U",
  "W1W",
  "W2",
  "W3",
  "W4",
  "W5",
  "W6",
  "W7",
  "W8",
  "W9",
  "WC1A",
  "WC1B",
  "WC1E",
  "WC1H",
  "WC1N",
  "WC1R",
  "WC1V",
  "WC1X",
  "WC2A",
  "WC2B",
  "WC2E",
  "WC2H",
  "WC2N",
  "WC2R",
  "WD17",
  "WD18",
  "WD19",
  "WD23",
  "WD24",
  "WD25",
  "WD3",
  "WD4",
  "WD5",
  "WD6",
  "WD7",
  "WD99"
]
